import {
  Address,
  RegistryAddress,
  SnippetAddress,
  SnippetAliasAddress,
} from "@pages/editor/stores/Address";

/**
 * Converts addressString to address
 * @param addressString is string in format s/{snippet name or id} or r/{registry name}
 */
export const addressStringToAddress = (addressString: string): Address => {
  const [prefix, fullName] = addressString.split("/");

  if (prefix === "s") {
    if (fullName.includes(":")) {
      return new SnippetAliasAddress(fullName);
    } else {
      return new SnippetAddress(fullName);
    }
  } else if (prefix === "r") {
    return new RegistryAddress(fullName);
  } else {
    throw new Error(`Unknown URL prefix: ${prefix}`);
  }
};
